<template>
  <ActionsMenu
    :actions="computedActions"
    :options="options"
    v-on="actionListeners"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
  </ActionsMenu>
</template>

<script setup lang="ts">
import { computed } from "vue";

import ActionsMenu from "@/components/ActionsMenu.vue";
import type { MenuAction, TippyOptions } from "@/typings/ui";

const props = defineProps<{
  actions: MenuAction[];
  options?: TippyOptions;
}>();

const emit = defineEmits<{
  (e: "action", action: MenuAction): void;
}>();

const computedActions = computed(() => {
  return props.actions
    .map((action) => ({
      ...action,
      disabled: action.disabled ?? !action.link,
      visible: action.visible ?? true
    }))
    .filter((action) => {
      if (action.hideWhenInactive && !action.link) return false;
      return true;
    });
});

const actionListeners = computed(() => {
  const listeners: Record<string, () => void> = {};
  for (const action of computedActions.value) {
    if (action.eventName) {
      listeners[action.eventName] = () => emit("action", action);
    }
  }
  return listeners;
});
</script>
